// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxes {
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0px 24px;
  width: 100%;
}

.boxes--container {
  display: flex;
  flex-wrap: nowrap;
  gap: 56px;
  justify-content: center;
  max-width: var(--grid-max-width);
  width: 100%;
}

.boxes--item {
  background: var(--color-primary-light-yellow);
  border-radius: 24px;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 56px;
  width: 50%;
}

.boxes--item .btn-primary {
  height: 52px;
  padding: 0px 28px;
  width: 222px;
  
  /* Garantir que o texto fique em uma única linha */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

@media (max-width: 768px) {
  .boxes--container {
    flex-wrap: wrap;
    gap: 32px;
  }

  .boxes--item {
    gap: 24px;
    padding: 40px;
    width: 100%;
  }

  .boxes--item h3 {
    font-size: var(--font-size-h5);
  }

  .boxes--item p.p1-paragraph,
  .boxes--item button.btn-primary {
    font-size: var(--font-size-p4-paragraph);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/boxes.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;;EAEZ,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,wCAAwC;EAC1C;AACF","sourcesContent":[".boxes {\n  align-content: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 0px 24px;\n  width: 100%;\n}\n\n.boxes--container {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 56px;\n  justify-content: center;\n  max-width: var(--grid-max-width);\n  width: 100%;\n}\n\n.boxes--item {\n  background: var(--color-primary-light-yellow);\n  border-radius: 24px;\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 32px;\n  padding: 56px;\n  width: 50%;\n}\n\n.boxes--item .btn-primary {\n  height: 52px;\n  padding: 0px 28px;\n  width: 222px;\n  \n  /* Garantir que o texto fique em uma única linha */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  .boxes--container {\n    flex-wrap: wrap;\n    gap: 32px;\n  }\n\n  .boxes--item {\n    gap: 24px;\n    padding: 40px;\n    width: 100%;\n  }\n\n  .boxes--item h3 {\n    font-size: var(--font-size-h5);\n  }\n\n  .boxes--item p.p1-paragraph,\n  .boxes--item button.btn-primary {\n    font-size: var(--font-size-p4-paragraph);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
